export enum AddressType {
  home = 1,
  work = 2,
  other = 3,
}
